import ModelUpdate from "@/models/ModelUpdate";
import Report from "@/models/report/Report";
import {ValidationRule} from "@/declarations/ValidationRule";
import ReportLineUpdate from "@/models/reportLine/ReportLineUpdate";
import {ReportLinesRules} from "@/models/reportLine/ReportLinesRules";

export default class ReportLinesUpdate extends ModelUpdate<Report> {

	public updatedReportLines!: ReportLineUpdate[];

	protected initializeWithDetailModelData(detailModel: Report): void {
		this.updatedReportLines = detailModel.reportLines.map(rl => new ReportLineUpdate(rl));
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'id':
				return ReportLinesRules.idRules;
			case 'text':
				return ReportLinesRules.textRules;
			case 'hourlyRate':
				return ReportLinesRules.hourlyRateRules;
			case 'dailyLumpSum':
				return ReportLinesRules.dailyLumpSumRules;
			case 'amount':
				return ReportLinesRules.amountRules;
			default:
				return [];
		}
	}

}
